<ng-container *transloco="let t">
    <div
        *ngIf="titleKey"
        class="bazis-browse-default__title"
    >
        {{ t(titleKey, titleParams) }}
    </div>

    <div class="bazis-btn-group">
        <div
            *ngFor="let option of options"
            class="bazis-btn-group__item"
        >
            <bazis-button
                [disabled]="true"
                [active]="value === option.name || value === t(option.nameKey) || values._.indexOf(option.id) > -1"
            >
                <ng-container *ngIf="option.name">
                    {{ option.name }}
                </ng-container>
                <ng-container *ngIf="option.nameKey">
                    {{ t(option.nameKey) }}
                </ng-container>
            </bazis-button>
        </div>
    </div>
</ng-container>
